import React from 'react'

interface PangoLogoProps {
  className?: string
}

export const PangoLogo: React.FC<PangoLogoProps> = ({ className = '' }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Vòng tròn kết nối */}
    <circle 
      cx="12" 
      cy="12" 
      r="3.5" 
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    
    {/* Đường kết nối */}
    <path 
      d="M5 12C5 8.13401 8.13401 5 12 5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path 
      d="M19 12C19 15.866 15.866 19 12 19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    
    {/* Điểm kết nối */}
    <circle 
      cx="12" 
      cy="5" 
      r="1.5" 
      fill="currentColor"
    />
    <circle 
      cx="12" 
      cy="19" 
      r="1.5" 
      fill="currentColor"
    />
  </svg>
) 